import React from "react";
import ScrollReveal from "./ScrollReveal/ScrollReveal";
import KineticText from "./KineticText";
import { useParallax } from "../Hooks/useScrollReveal";

const ParallaxImg = ({ src, alt, speed }) => {
  const ref = useParallax({ speed });
  return (
    <div className="overflow-hidden rounded-lg shadow-md h-[150px] sm:h-[250px]">
      <img
        ref={ref}
        src={src}
        alt={alt}
        className="w-full h-[130%] object-cover -mt-[15%]"
      />
    </div>
  );
};

const HomeAbout = () => {
  return (
    <div className="flex flex-col md:flex-row justify-center items-center gap-10 mt-10 w-[90vw] md:w-[80vw] mx-auto">
      {/* Left: Image Gallery */}
      <ScrollReveal className="w-full md:w-1/2 grid grid-cols-2 gap-4" stagger={0.1}>
        <ParallaxImg src="https://i.ibb.co/nN3X1gCW/Factory2.jpg" alt="Perfume 1" speed={0.1} />
        <ParallaxImg src="https://i.ibb.co/sdndxFvp/FACTORY1.jpg" alt="Perfume 2" speed={-0.1} />
        <ParallaxImg src="https://i.ibb.co/p6H4K7TL/factory5.jpg" alt="Perfume 3" speed={0.1} />
        <ParallaxImg src="https://i.ibb.co/G3kpQYK5/factory4.jpg" alt="Perfume 4" speed={-0.1} />
      </ScrollReveal>

      {/* Right: Text Content */}
      <ScrollReveal className="w-full md:w-1/2 sm:text-center md:text-left" direction="up" distance={40} stagger={0.2}>
        <KineticText as="p" splitBy="word" className="text-3xl sm:text-5xl my-6 text-[#035A6F] font-bold heading-font">
          NEXTCARE PERFUMES & COSMETICS
        </KineticText>
        <p className="text-lg md:text-xl mb-4 text-black">
          As a perfume and cosmetics manufacturer, Nextcare offers full services
          for third parties & contract manufacturing.
        </p>
        <p className="text-base md:text-lg text-black text-opacity-70">
          In life, it's not just about what you do, but how you do it, and, above
          all, who you do it with. That's what really sets us apart: We are
          full-service perfume and cosmetics manufacturers, taking care of every
          detail, with a great team of professionals who direct and design the
          entire process, so that you feel supported and have the assurance that
          you have chosen the best solution.
        </p>
      </ScrollReveal>
    </div>
  );
};

export default HomeAbout;
